import React from 'react';
import { icons } from '@ublend-npm/aulaui-next';
import { createCloudFileProviderPlugin } from '../cloudFileProvider/createCloudFileProvider';
import { AulaPlugin } from '../plugins';
import { googleDriveType } from './googleDriveType';
import { openGoogleDrivePicker } from './googleDrivePicker';

export const googleDrive: AulaPlugin = createCloudFileProviderPlugin({
  name: 'Google Drive',
  elementType: googleDriveType,
  icon: <icons.GoogleDrive />,
  onRequestFilePicker: openGoogleDrivePicker,
});
